const regex = /^((?=(09))[0-9]{10})$/;
const getMessage = '手機號碼請填寫正確格式(半形數字，不可有空格)';
const validate = (value) => regex.test(value);

/** 自訂驗證電話格式 */
export default {
  getMessage,
  validate,
};
